import { SVGProps, Ref, forwardRef } from 'react';

export const EnvelopeOpenedFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.865.5h8.265v7.156L7.998 9.373 3.865 7.656zm1.8 5.532h4.666v-1.4H5.665z"
                    fill="currentColor"
                />
                <path d="m15.687 6.179-2.157.896V3.878c1.122.395 1.803 1.124 2.157 2.301" fill="currentColor" />
                <path
                    d="M15.944 7.588q.052.574.052 1.244v1.333c0 3.999-1.333 5.332-5.332 5.332H5.332c-4 0-5.332-1.333-5.332-5.332V8.832q0-.67.052-1.244l7.946 3.3z"
                    fill="currentColor"
                />
                <path d="M2.465 7.075.31 6.179c.354-1.177 1.035-1.906 2.156-2.3z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
EnvelopeOpenedFilledSize16Glyph.displayName = 'EnvelopeOpenedFilledSize16Glyph';
